import queryString from 'query-string';
import { ListOptions, QueryParams } from './request';
import mapKeys from 'lodash/mapKeys';
import merge from 'lodash/merge';

export const toListQueryString = (opts?: ListOptions) => {
  if (opts === undefined) {
    return '';
  }

  const { filters, pagination, sort } = opts;
  const qp: QueryParams = {};

  if (pagination) {
    qp.page = pagination.page;
    qp.per = pagination.per;
  }

  if (filters) {
    const filterParams = mapKeys(filters, (_, k) => `filter[${k}][eq]`);

    merge(qp, filterParams);
  }

  if (sort) {
    const sortParams = sort.map(
      (opt) => `${opt.direction === 'asc' ? '' : '-'}${opt.key}`
    );

    qp['sort'] = sortParams.join(',');
  }

  return queryString.stringify(qp);
};
